"use strict";

(function e(t, n, r) {
  function s(o, u) {
    if (!n[o]) {
      if (!t[o]) {
        var a = typeof require == "function" && require;if (!u && a) return a(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
      }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
        var n = t[o][1][e];return s(n ? n : e);
      }, l, l.exports, e, t, n, r);
    }return n[o].exports;
  }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
    s(r[o]);
  }return s;
})({ 1: [function (require, module, exports) {
    module.exports = function (name) {
      var SEARCH = window.location.search.substr(1);
      var reg = new RegExp("(^|&)" + name + "=([\\d\\w-.]+)(&|$)");
      var value = SEARCH.match(reg);

      return value ? value[2] : '';
    };
  }, {}], 2: [function (require, module, exports) {
    'use strict';

    var param = require('bmh/param');
    var FROM = param('from');
    var vm = new Vue({
      el: '#app',
      data: {
        user_name: '',
        home_area: '',
        phone_num: '',
        new_flag: false,
        old_flag: false,
        is_from_android: false,
        is_from_ios: false,
        house_state: '',
        entry_type: 709502,
        city: '',
        obj: {
          name: '',
          area: '',
          house_state: '',
          mobile: ''
        },
        send_url: '//m.tugou.com/ju/yu/index/apply/'
      },
      created: function created() {
        var url_href = location.href;
        var ua = navigator.userAgent.toLowerCase();
        if (/app/.test(url_href)) {
          if (/android/.test(ua)) {
            this.is_from_android = true;
          } else if (/iphone|ipad|ipod/.test(ua)) {
            this.is_from_ios = true;
          }
        }
        // if (FROM == "app") {
        //   if (/android/.test(ua)) {
        //     this.is_from_android = true;
        //   } else if (/iphone|ipad|ipod/.test(ua)) {
        //     this.is_from_ios  =true;
        //   }
        // }
        if (this.is_from_android) {
          this.entry_type = 304401;
        }
        if (this.is_from_ios) {
          this.entry_type = 204401;
        }
        console.log(this.entry_type);
      },

      methods: {
        newflag: function newflag() {
          this.new_flag = true;
          this.old_flag = false;
          this.house_state = 1;
        },

        oldflag: function oldflag() {
          this.new_flag = false;
          this.old_flag = true;
          this.house_state = 5;
        },
        newflagDisable: function newflagDisable() {
          this.new_flag = false;
        },
        oldflagDisable: function oldflagDisable() {
          this.old_flag = false;
        },

        submit: function submit() {
          var _this = this;
          console.log(_this.city);
          _this.obj.name = _this.user_name;
          _this.obj.area = _this.home_area;
          _this.obj.house_state = _this.house_state;
          _this.obj.mobile = _this.phone_num;
          _this.obj.city = _this.city;
          _this.obj.entry_type = _this.entry_type;
          var obj = _this.obj;
          if (_this.obj.name && _this.obj.area && _this.obj.house_state && _this.obj.mobile && _this.city > 0) {
            _this.$http.post(_this.send_url, obj).then(function (response) {
              if (response.data.error == 0) {
                alert("抢购成功");
                window.location.href = '//m.tugou.com/success/success/';
              } else if (response.data.message == 'tel规则错误') {
                alert("手机号码格式错误");
              } else if (response.data.message == "您已经过报名！") {
                alert("同一手机号码只可报名一次");
              } else {
                alert(response.data.message);
              }
            });
          } else {
            alert("信息输入不完整");
          }
        }
      }
    });
  }, { "bmh/param": 1 }] }, {}, [2]);